import { observer } from 'mobx-react-lite'
import { Box, IconButton } from 'shared/ui'
import { Tabs, type ITabItem } from 'shared/ui/Tabs'
import { type IRcsPreviewTabs } from 'pages/settings/pages/rcsV2/pages/create/SenderDetails/store/type'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'
import { useSenderDetailsContext } from 'pages/settings/pages/rcsV2/pages/create/SenderDetails/hooks/useSenderDetailsContext'
import { RcsConversationPreview } from './RcsConversationPreview/RcsConversationPreview'
import { RcsProfilePreview } from './RcsProfilePreview/RcsProfilePreview'

import styles from './styles.module.scss'

export const SenderPreview = observer(() => {
  const { closeWizard } = useRcsWizardContext()
  const { previewTabs, activeTab, setActiveTab } = useSenderDetailsContext()

  const tabs: ITabItem<IRcsPreviewTabs>[] = previewTabs.map((tab) => ({
    key: tab.value,
    name: tab.label,
  }))

  return (
    <Box width={'100%'}>
      <div className={styles.header}>
        <Tabs
          tabs={tabs}
          activeTabKey={activeTab}
          handleSelectTab={(tab) => setActiveTab(tab.key)}
          variant={'simpleWithoutBorder'}
          tabsClassName={styles.tabs}
        />
        <IconButton
          ariaLabel='close_setting'
          icon='close'
          variant='icon'
          color='tertiary'
          size='medium'
          onClick={closeWizard}
        />
      </div>
      <Box padding={'48px 63px'}>
        {activeTab === 'profile' && <RcsProfilePreview />}
        {activeTab === 'conversation' && <RcsConversationPreview />}
      </Box>
    </Box>
  )
})
